module.exports = __webpack_public_path__ + "static/media/template-1.e0afa5ba.svg";